import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Sparkles } from 'lucide-react';
interface BonusProps {
  number: string;
  title: string;
  image: string;
  description: string;
  value: string;
}
export function BonusCard({
  number,
  title,
  image,
  description,
  value
}: BonusProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} whileHover={{
    y: -10
  }} className="bg-white border-2 border-violet-100 rounded-3xl overflow-hidden flex flex-col shadow-lg hover:shadow-2xl hover:border-violet-200 transition-all duration-300 relative group" data-id="element-169" data-mp="2x507xlxqs81g">
      {/* Animated Ribbon Label */}
      <div className="absolute top-0 left-0 z-30 overflow-hidden w-32 h-32 pointer-events-none" data-id="element-170" data-mp="2e6e6u7286gxj">
        <motion.div initial={{
        x: -100,
        y: -100,
        rotate: -45
      }} animate={{
        x: -35,
        y: 25,
        rotate: -45,
        scale: [1, 1.05, 1]
      }} transition={{
        scale: {
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }
      }} className="bg-gradient-to-r from-violet-600 via-violet-500 to-violet-600 text-white font-black text-[10px] py-1.5 w-[180px] text-center shadow-lg uppercase tracking-[0.2em] border-y border-white/20" data-id="element-171" data-mp="1hohvhwredm5n">
          <div className="relative overflow-hidden" data-id="element-172" data-mp="1ic71ti1dk040">
            {/* Shimmer effect on ribbon */}
            <motion.div animate={{
            x: ['-100%', '200%']
          }} transition={{
            duration: 3,
            repeat: Infinity,
            ease: 'linear'
          }} className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-173" data-mp="1df71lnr7hrkt" />
            BONO {number}
          </div>
        </motion.div>
      </div>

      <div className="absolute top-4 right-4 z-20" data-id="element-174" data-mp="2yrgpopdczhk6">
        <motion.div animate={{
        scale: [1, 1.1, 1]
      }} transition={{
        duration: 2,
        repeat: Infinity
      }} className="bg-violet-600 text-white p-2 rounded-full shadow-lg" data-id="element-175" data-mp="2yq5liog047sj">
          <Gift size={16} data-id="element-176" data-mp="s1n7rpdqkkvi" />
        </motion.div>
      </div>

      <div className="aspect-[4/3] overflow-hidden bg-violet-50 relative" data-id="element-177" data-mp="wugc4c5alr72">
        <img src={image} alt={title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-178" data-mp="i5216zm2j1pk" />
        <div className="absolute inset-0 bg-gradient-to-t from-violet-950/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-179" data-mp="n3bz3hz6ggev" />
      </div>

      <div className="p-8 flex-grow flex flex-col relative" data-id="element-180" data-mp="1arv7rym52v7h">
        <div className="flex items-center gap-2 mb-3" data-id="element-181" data-mp="1frhfxtn41l9f">
          <Sparkles size={14} className="text-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-182" data-mp="10vs2ijvzqggb" />
        </div>

        <h3 className="text-xl font-black text-violet-950 mb-4 leading-tight group-hover:text-violet-600 transition-colors" data-id="element-183" data-mp="15tlb1jkrnmjr">
          {title}
        </h3>
        <p className="text-violet-800/70 text-sm mb-6 flex-grow" data-id="element-184" data-mp="3qku3tgjnl7b2">
          {description}
        </p>
        <div className="pt-4 border-t border-violet-50" data-id="element-185" data-mp="28n8jywexl11f">
          <p className="text-violet-300 text-xs line-through" data-id="element-186" data-mp="28lnpf6sm9i3k">
            VALORADO EN {value}
          </p>
          <p className="text-violet-600 font-black text-lg" data-id="element-187" data-mp="23nw08kjcwa32">HOY GRATIS</p>
        </div>
      </div>
    </motion.div>;
}